import { type InferType } from "yup";
import { t } from "i18next";
import { getPersonSchema } from "@/services/api";
import { testAtLeastOneTrue } from "@/shared/yup";

export const getGeneralInfoTabSchema = () =>
  getPersonSchema()
    .pick([
      "id",
      "firstName",
      "middleName",
      "lastName",
      "group",
      "gender",
      "birthday",
      "title",
      "avatarFile",
      "tags",
      "additionalInformation",
      "websites",
      "phones",
      "emails",
      "socialNetworks",
      "addresses",
      "anniversaries",
    ])
    .test("at-least-one-true", `*${t("validation.fillInAtLeastOneField")}`, function (value) {
      const isValid = value.title || value.firstName || value.lastName;
      if (!isValid) {
        return this.createError({
          message: `*${t("validation.fillInAtLeastOneField", { value: t("validation.titleNameSname") })}`,
          path: "generalAtLeast",
        });
      }
      return true;
    })
    .test("at-least-one-true", function (value) {
      return testAtLeastOneTrue(this, value, ["title", "firstName", "lastName"]);
    });

export type GeneralInfoTabFormValues = InferType<ReturnType<typeof getGeneralInfoTabSchema>>;
